import React from 'react';
import PropTypes from 'prop-types';

const LoopPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.219 3.28a.752.752 0 0 1 1.062 0l4.012 4.013a1 1 0 0 1 0 1.414l-4.012 4.013A.75.75 0 0 1 12 12.189V10H9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a7 7 0 0 1-7-7v-6a7 7 0 0 1 7-7h3V3.811c0-.199.079-.39.219-.531zM22 6h1a7 7 0 0 1 7 7v6a7 7 0 0 1-7 7h-3v2.189a.75.75 0 0 1-1.281.53l-4.012-4.012a.999.999 0 0 1 0-1.414l4.012-4.013a.752.752 0 0 1 1.281.53V22h3a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3h-1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z"
    />
  );
};

LoopPath.propTypes = {
  fill: PropTypes.string,
};

export default LoopPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/loop.jsx